import React, {useContext, useState, useEffect, useImperativeHandle, forwardRef}  from 'react';
import { Space, Dropdown, Menu, Col, Row, Badge, Layout, Input, Typography, Button, Select, Popover, message, Form, InputNumber, Divider } from 'antd';
import { Link, Navigate } from "react-router-dom";
import CustomAvatar from '../Widgets/Avatar/Avatar';
import { BsBellFill } from "react-icons/bs";
import axios from "axios";
import { DownOutlined, CloseOutlined, SearchOutlined } from '@ant-design/icons';
//componentes
import { User, SetUser } from '../../Hooks/Logged'

import '../../Styles/Global/header.scss'

const { Header } = Layout;
const { Search } = Input;
const { Title, Paragraph } = Typography;

/**
 * @const Navbar
 * @description Header del sistema
 * @param {*} {  showResponsiveSidebar, showSearch, setFilterSearch, filterSearchVal }
 */
const Navbar = forwardRef((props,ref) => {
 
 	let { setFilterSearch } = props

	let user = useContext(User)
    let setUser = React.useContext(SetUser)
    let [redirect, setRedirect] = useState(false)
    let [value, setValue] = useState("")
    let [serched, setSerched] = useState("")

    /**
     * @const cerrarSesion
     * @description Cierra la sesion
     */
    const cerrarSesion = () => {

		axios.get("/logout")
			.then(e => {
				setUser(undefined);
				sessionStorage.clear();
				setRedirect(true)
			})
			.catch(e => {
				console.log("ERROR");
			})

    };

	/**
	* @const UserMenu
	* @description Muestra el Menu del dashboard
	*/
	const UserMenu = () => {
			if (!user) return null;
			return (
				<Col flex="auto" className="header-content" >
					{redirect ? <Navigate to={'/'}  replace /> : null}
					<Row justify="space-beetwen" align="middle" style={{width: '100%', }}>
						<Col style={{ display:'flex', justifyContent: 'start', alignItems: 'center',}} xs={16}  md={16}  xl={18}   >
							<div className="header-search">
								<Search
									placeholder="Buscar"
									onSearch={(e) => { 
										if(e !== serched){
											setFilterSearch(e)
											setSerched(e)
										}else{
											setSerched("")
											setValue("")
											setFilterSearch(null)
										}
									}}
									value={value}
									id="inputFilterSearch"
									enterButton={serched ? <CloseOutlined/> : <SearchOutlined />}
									onChange={(e)=>{
										setValue(e.target.value)
										if(e.target.value !== serched){
											setSerched("")
										}
									}}
									onPressEnter={()=>{}}

									//className="input-global-search"
								/>
							</div>
						</Col>
						<Col xs={8}  md={8}  xl={6}  >
							<Row type="flex" justify="center" align="middle" className=" header-options">
								<Col flex={2} className="option-notificacion" >
									{/* <Badge count={0}>
										<BsBellFill className="icon-bell" />
									</Badge> */}
								</Col>
								<Col flex={3} className="option-menu">
									<Dropdown
										arrow={true}
										overlay={
											<Menu>
												<Menu.Item key="0" onClick={cerrarSesion}>
													Cerrar Sesión
												</Menu.Item>
											</Menu>
										} trigger={['click']}>
										<Link to="#" onClick={e => e.preventDefault()} className="header-user-link">
											<CustomAvatar
												size={45}
												url={
													user?.avatar
													? 	{
															url: axios.defaults.baseURL + `/usuarios/avatar/${user._id}`,
															avatar: true,  
															name: `${user.nombre} ${user.apellidos}`
														}
													: null
												}
												placeholder={true}
												name={`${user.nombre} ${user.apellidos}`}
											/>
											<DownOutlined style={{ marginLeft: 8, color: '#2d348c' }} />
										</Link>
									</Dropdown>
								</Col>
							</Row>
						</Col>
					</Row>	
				</Col>
			)
	}

	useImperativeHandle(ref, () => ({
    	clear() {
    		console.clear()
      		setValue("");
      		setSerched("");
      		setFilterSearch(null)
    	}
  	}));

	return (
		<Header className="header" >
			<Row type="flex" className="row-header-content" >
				<Col className="header-logo"  xs={24} sm={24}>
					<div className="logo">
						<img src={'/img/logo_white.png'} alt="logo" />
					</div>
				</Col>
				{UserMenu()}
			</Row>
		</Header>
	);

})

export default Navbar;